import type { Market } from '@backmarket/http-api/src/api-models/Market'
import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'

import {
  PAYMENT_METHODS_ADVERTISING,
  PAYMENT_METHODS_ADVERTISING_BY_COUNTRY,
  PAYMENT_METHODS_ADVERTISING_BY_LOCALE,
} from '../config/advertising'
import type { PaymentAdvertisingConfig } from '../types/PaymentAdvertisingConfig'
import type { PaymentAdvertisingId } from '../types/PaymentAdvertisingId'

/**
 * Sorts payment methods for advertising based on the current locale or marketplace
 * country code if a specific order is defined for either.
 *
 * Locale-level overrides take precedence over country-level overrides.
 */

export function sortPaymentMethodsAdvertisement(
  market: Market,
  locale: Bcp47Locale,
) {
  const paymentMethodsAdvertising = Object.entries(
    PAYMENT_METHODS_ADVERTISING,
  ) as [PaymentAdvertisingId, PaymentAdvertisingConfig][]

  if (locale in PAYMENT_METHODS_ADVERTISING_BY_LOCALE) {
    const specificAdvertisingIdOrder =
      PAYMENT_METHODS_ADVERTISING_BY_LOCALE[locale]
    if (specificAdvertisingIdOrder !== undefined) {
      return specificAdvertisingIdOrder.map(
        (id: PaymentAdvertisingId) =>
          [id, PAYMENT_METHODS_ADVERTISING[id]] as const,
      )
    }
  }

  if (market.countryCode in PAYMENT_METHODS_ADVERTISING_BY_COUNTRY) {
    const specificAdvertisingIdOrder =
      PAYMENT_METHODS_ADVERTISING_BY_COUNTRY[market.countryCode]
    if (specificAdvertisingIdOrder !== undefined) {
      return specificAdvertisingIdOrder.map(
        (id: PaymentAdvertisingId) =>
          [id, PAYMENT_METHODS_ADVERTISING[id]] as const,
      )
    }
  }

  return paymentMethodsAdvertising
}
